const _STORE_ = {
};

const _COMPONENTS_ = {  
};

const createApp = (config = {}) => {
  return PetiteVue.createApp({
    $delimiters: ["${", "}"],
    ..._STORE_,
    ..._COMPONENTS_,
    ...config
  })
}

const createStore = (namespace, config = {}) => {
  if (!getStore(namespace)) _STORE_[namespace] = PetiteVue.reactive(config);
  return getStore(namespace);
};

const getStore = (namespace) => _STORE_[namespace]

const createComponent = (name, component = () => {}) => {
  if (!_COMPONENTS_[name]) _COMPONENTS_[name] = component;
  return _COMPONENTS_[name];
};

const dispatch = (name, data, el = window) => {
  el.dispatchEvent(new CustomEvent(name, { detail: data }));
};

const listen = (name, callback = () => {}, el = window) => {
  if (Array.isArray(name)) {
    name.forEach((n) => listen(n, callback, el));
    return;
  }
  el.addEventListener(name, callback, false);
};

const off = (name, callback = () => {}, el = window) => {
  if (Array.isArray(name)) {
    name.forEach((n) => off(n, callback, el));
    return;
  }
  el.removeEventListener(name, callback, false);
};